import { DOCUMENT_ACCESS_LEVEL } from '../Document.constants'

export function getAccessLevelOptions(t) {
  return [
    {
      label: t('DocumentsFolder.AccessLevelAllowKey'),
      value: DOCUMENT_ACCESS_LEVEL.allow,
    },
    {
      label: t('DocumentsFolder.AccessLevelReadOnlyKey'),
      value: DOCUMENT_ACCESS_LEVEL.readonly,
    },
    {
      label: t('DocumentsFolder.AccessLevelDenyKey'),
      value: DOCUMENT_ACCESS_LEVEL.deny,
    },
  ]
}

// The form keeps plain level strings; options are mapped on the field boundary
export function getAccessLevelValueProps(options) {
  return field => ({
    value: options.find(option => option.value === field.value),
  })
}

export function getAccessLevelNextValue(option) {
  return option?.value
}
